// base url
var path = '/';
var token = $('html').attr('token');
var lang = $('html').attr('lang');

$(document).ready(function() {

	// maintien de la session
	function check_session(path, lang) {
		$.post(path+'Connections/request/xhr/notification/check.php', {lang: lang, token: token}, function(data){
			if(data.session==false)
			{
				location.reload();	
			}
		}, 'json');
	}	
	
	setInterval(function() {
		check_session(path, lang);
	},1000*60*10); // 10 min

	function xhr_data(file = null, data, $this) {
	    
	    const handlers = {
	        /*'jobs/apply': () => {
	            data.push(
	                { name: 'job', value: $('[data-job]').data('job') }
	            );

	            // Vérification si un fichier a bien été uploadé via Dropzone
	            if (myDropzone && myDropzone.getAcceptedFiles().length > 0) {
	                let uploadedFile = myDropzone.getAcceptedFiles()[0]; // Récupère le fichier

	                if (uploadedFile && uploadedFileId) {
	                    data.push({ name: 'id', value: uploadedFileId });
	                } else {
	                    
                    	data.push({ name: 'id', value: 0 });
	                }
	            } else {
                    data.push({ name: 'id', value: 0 });
	                showError(translate.CV_REQUIRED_TO_APPLY);
	                return false; // Empêche l'envoi du formulaire si aucun fichier
	            }
	        },*/
	        'jobs/apply': () => {
	            data.push(
	                { name: 'job', value: $('[data-job]').data('job') },
	                { name: 'form', value: $('[data-form]').data('form') }
	            );

	            // Vérification si un fichier a bien été uploadé via Dropzone
	            if (myDropzone && myDropzone.getAcceptedFiles().length > 0) {
	                let uploadedFile = myDropzone.getAcceptedFiles()[0]; // Récupère le fichier

	                if (uploadedFile && uploadedCvId) {
	                    data.push({ name: 'id', value: uploadedCvId });
	                } else {
	                    
                    	data.push({ name: 'id', value: 0 });
	                }
	            } else {
                    data.push({ name: 'id', value: 0 });
	                showError(translate.CV_REQUIRED_TO_APPLY, '#cv-error');
	                return false; // Empêche l'envoi du formulaire si aucun fichier
	            }
	        },
	        'jobs/remove-cv': () => {
	            data.push(
	                { name: 'type', value: $('[data-type]').data('type') },	                
	                { name: 'form', value: $('[data-form]').data('form') }
	            );
	        },'generator/job': () => {
			    const steps = [
			        { icon: "fa-sparkles", text: "Analyse du profil recherché..." },
			        { icon: "fa-brain-circuit", text: "Extraction des compétences clés..." },
			        { icon: "fa-pen-nib", text: "Rédaction de l'offre par l'IA..." },
			        { icon: "fa-list-check", text: "Génération des questions d'entretien..." }
			    ];

			    var loader = `
			        <div class="d-flex flex-column align-items-center justify-content-start text-center h-100">
			            <div class="position-relative mb-4" style="width: 110px; height: 110px;">
			                <svg width="110" height="110" viewBox="0 0 110 110" style="transform: rotate(-90deg);">
			                    <circle cx="55" cy="55" r="50" fill="none" stroke="#f3f3f3" stroke-width="6" />
			                    <circle id="progress-bar" cx="55" cy="55" r="50" fill="none" stroke="#21b9b6" 
			                            stroke-width="6" stroke-dasharray="314" stroke-dashoffset="314" 
			                            stroke-linecap="round" style="transition: stroke-dashoffset 0.8s ease-in-out;" />
			                </svg>
			                <div id="icon-container" class="position-absolute top-50 start-50 translate-middle bg-white rounded-circle" 
			                     style="width: 85px; height: 85px; display: flex; align-items: center; justify-content: center; z-index: 2;">
			                    <i class="fa-solid fa-circle-notch fa-spin fa-xl text-primary"></i>
			                </div>
			            </div>
			            <h3 id="ai-loader-text" class="h5 fw-bold text-secondary mb-2">Initialisation...</h3>
			            <p id="ai-loader-subtext" class="text-muted small">L'IA de Genius People prépare votre contenu.</p>
			        </div>`;

			    $('#job-result').html(loader);

			    let currentStep = 0;
			    const totalSteps = steps.length;
			    const circumference = 314;

			    if (window.jobLoaderInterval) clearInterval(window.jobLoaderInterval);

			    window.jobLoaderInterval = setInterval(() => {
			        const $iconContainer = $('#icon-container');
			        const $text = $('#ai-loader-text');
			        const $subtext = $('#ai-loader-subtext');
			        const $progressBar = $('#progress-bar');

			        if ($progressBar.length === 0) { 
			            clearInterval(window.jobLoaderInterval);
			            return;
			        }

			        if (currentStep < totalSteps) {
			            // --- ÉTAPE NORMALE ---
			            const step = steps[currentStep];
			            const progress = (currentStep + 1) / (totalSteps + 1); // +1 pour garder de la marge
			            const offset = circumference - (progress * circumference);
			            
			            $progressBar.css('stroke-dashoffset', offset);

			            $iconContainer.fadeOut(300, function() {
			                $(this).html('<i class="fa-solid ' + step.icon + ' fa-beat-low fa-xl text-primary"></i>');
			                $(this).fadeIn(300);
			            });

			            $text.fadeOut(300, function() {
			                $(this).text(step.text).fadeIn(300);
			            });

			            currentStep++;
			        } else {
			            // --- ÉTAPE DE "STALLING" (Temps API plus long) ---
			            // On bloque la barre à 98%
			            $progressBar.css('stroke-dashoffset', circumference * 0.08);

			            if (!$text.hasClass('stalling')) {
			                $text.addClass('stalling');
			                
			                $iconContainer.fadeOut(300, function() {
			                    $(this).html('<i class="fa-solid fa-microchip fa-beat fa-xl text-primary"></i>');
			                    $(this).fadeIn(300);
			                });

			                $text.fadeOut(300, function() {
			                    $(this).text("Finalisation approfondie...").fadeIn(300);
			                });

			                $subtext.fadeOut(300, function() {
			                    $(this).text("L'IA peaufine les derniers détails de votre offre.").fadeIn(300);
			                });
			            }
			        }
			    }, 4000); // On ralentit un peu le cycle pour laisser respirer l'IA

			    // Scroll
			    var headerHeight = $('#header-sticky').outerHeight();
			    $('html, body').animate({
			        scrollTop: $('#job-result').offset().top - (headerHeight + 20)
			    }, 800);
			},
	        'generator/send': () => {
	        	data.push(
	                { name: 'id', value: $('[data-id]').data('id') }
	            );
			}	
	    };

	    if (handlers[file]) {
	        handlers[file]();
	    } else {
	        return true;
	    }
	}

	// data à passer en cas de validation via SweetAlert (Swal)
	function xhr_data_confirm(file = null, data, $this) {

	    /*const handlers = {
	    	'invoice/paied-invoice': () => {
	            data.push(
	                { name: 'invoice', value: $this.closest('[data-invoice]').data('invoice') },
	                { name: 'paied-at', value: $('#paied-at').val() }
	            );
	        }
	    };

	    if (handlers[file]) {
	        handlers[file]();
	    } else {
	        return true;
	    }*/
	}

	// personnalise les callback en cas de succès dans la fonction xhr_send()
	function xhr_success(callback = null, response, data, path, $this, lang) {
	    const dataObj = {};
	    for (let i = 0; i < data.length; i++) {
	        dataObj[data[i].name] = data[i].value;
	    }

	    const handlers = {
	        'contact/send': () => {
	            $('#form-contact').load(path+'Connections/request/xhr/contact/contact-success.php');
	            var $target = $('#form-contact');
				if ($target.length) {
					// calcule la position cible moins 100px
					var top = Math.max($target.offset().top - 100, 0);
					$('html, body').animate({ scrollTop: top }, 600);
				}
	        },
	        'jobs/remove-cv': () => {
	            $this.removeAttr('data-id');
	            $this.removeAttr('data-type');
	        },
	        'generator/job': () => {
	            $('#job-result').html(response.output);

	            let newUrl = 'job-description-generator?ref=' + response.id;

	            history.pushState({ job_id: response.id }, '', newUrl);
	        },
	        'generator/send': () => {

    			var successContent = `
		            <div class="text-center p-4">
		                <div class="mb-4">
		                    <i class="fa-solid fa-circle-check fa-4x text-success"></i>
		                </div>
		                <h3 class="h4 fw-bold mb-3">C'est en route !</h3>
		                <p class="text-muted mb-4">
		                    Votre guide de recrutement et votre offre ont été envoyés à <strong>${dataObj['email']}</strong>.
		                </p>
		                <div class="d-grid gap-2">
		                    <a href="https://app.genius-people.com/fr/signup?gen=${response.token}" class="btn btn-primary btn-lg">
		                        Publier cette offre maintenant (Gratuit)
		                    </a>
		                    <a href="https://genius-people.com/fr/job-preview/${response.token}/" class="btn btn-outline-primary" id="btn-view-offer" target="_blank">
		                        Voir mon offre sur la page
		                    </a>
		                </div>
		            </div>`;
		        
		        $('#modal-questions .modal-body').html(successContent);

		        // 2. Action au clic sur "Voir mon offre"
		        // $('#btn-view-offer').on('click', function() {
		        //     $('#modal-questions').modal('hide');
	            // 	$('.modal-backdrop').remove(); // Supprime l'overlay (nom de classe type Bootstrap)
		        // });
	        },

	        // Ajoutez d'autres handlers ici...

	        default: () => {
	            return true;
	        },
	    };

	    (handlers[callback] || handlers.default)();
	}


	// fonction principale pour l'envoie et le controle de requêtes ajax
	function xhr_send(path, token, $this, file, lang) {
	    // Arrêter tout appel AJAX en cours pour cet élément
	    const ongoingAjaxCall = $this.data('ongoingAjaxCall');
	    if (ongoingAjaxCall) {
	        ongoingAjaxCall.abort();
	        $this.data('ongoingAjaxCall', null);
	    }

	    file = file || $this.data('xhr');

	    let loading = false;
	    let text = '';
	    if ($this.prop('tagName') === 'BUTTON' && $this.is('[data-kt-indicator]')) {
	        loading = true;
	        text = $this.find('.indicator-label').html();
	    }

	    const type = $this.data('type') || null;
	    const formSelector = `#${$this.closest('form').attr('id')}`;
	    let data = getFormData(formSelector, token, lang);

	    // Appeler la fonction xhr_data d'abord
		xhr_data(file, data, $this);

		// Ensuite, récupérer l'id à partir de l'élément le plus proche avec l'attribut data-id
		const id = $this.closest('[data-id]').data('id');

		// Si l'id existe et qu'il n'est pas déjà présent dans data, l'ajouter
		if (id !== undefined && !data.some(item => item.name === 'id')) {
		    data.push({ name: 'id', value: id });
		}

	    // Supprimer les classes d'erreur
	    $('.is-invalid').removeClass('is-invalid');

	    if (type === 'delete' || type === 'alert') {
	        handleDeleteOrAlert(type, data, path, file, token, lang, $this, loading, text);
	    } else {
	        handleStandardRequest(data, path, file, token, lang, $this, loading, text);
	    }
	}

	// Fonction pour obtenir les données du formulaire et inclure les éditeurs TinyMCE
	function getFormData(formSelector, token, lang) {
	    let data = $(formSelector).serializeArray();
	    data.push({ name: 'token', value: token }, { name: 'lang', value: lang });

	    // Inclure le contenu des éditeurs TinyMCE
	    $('.tinymce, .tinymce-light, .editor').each(function () {
	        const currentEditorId = $(this).attr('id');
	        const val = tinyMCE.get(currentEditorId).getContent();
	        data = data.map(field => (field.name === currentEditorId ? { ...field, value: val } : field));
	    });

	    return data;
	}

	// Fonction pour gérer les requêtes de type "delete" ou "alert"
	function handleDeleteOrAlert(type, data, path, file, token, lang, $this, loading, text) {
	    // Options par défaut pour SweetAlert
	    const swalOptions = {
	        text: typeof swal_text !== 'undefined' ? swal_text : translate.DELETE_RECORD,
	        icon: typeof swal_icon !== 'undefined' ? swal_icon : 'warning',
	        confirmButtonText: typeof swal_confirm !== 'undefined' ? swal_confirm : translate.YES_DELETE,
	        cancelButtonText: typeof swal_cancel !== 'undefined' ? swal_cancel : translate.NO_BACK,
	        confirmButtonClass: typeof swal_confirm_btn !== 'undefined' ? swal_confirm_btn : 'btn-primary',
	    };

	    Swal.fire({
	        html: swalOptions.text,
	        icon: swalOptions.icon,
	        showCancelButton: true,
	        buttonsStyling: false,
	        confirmButtonText: swalOptions.confirmButtonText,
	        cancelButtonText: swalOptions.cancelButtonText,
	        customClass: {
	            confirmButton: `btn ${swalOptions.confirmButtonClass}`,
	            cancelButton: 'btn btn-light-primary',
	        },
	    }).then(result => {
	        if (result.value) {
	        	xhr_data_confirm(file, data, $this)
	            const jqXHR = $.post(
	                `${path}request/${file}.php`,
	                data,
	                responseHandler('front', data, file, token, path, lang, $this, loading, text),
	                'json'
	            ).always(() => {
	                $this.data('ongoingAjaxCall', null);
	            });

	            // Stocker l'appel AJAX en cours
	            $this.data('ongoingAjaxCall', jqXHR);
	        } else {
	            if (loading) {
	                $this.attr('data-kt-indicator', 'off');
	                $this.html(text.replace('Please wait...', ''));
	            }
	        }
	    });

	    datepicker_today();
	}

	// Fonction pour gérer les requêtes standards
	function handleStandardRequest(data, path, file, token, lang, $this, loading, text) {
	    const jqXHR = $.post(
	        `${path}request/${file}.php`,
	        data,
	        responseHandler('front', data, file, token, path, lang, $this, loading, text),
	        'json'
	    ).always(() => {
	        $this.data('ongoingAjaxCall', null);
	    });

	    // Stocker l'appel AJAX en cours
	    $this.data('ongoingAjaxCall', jqXHR);
	}

	// Fonction pour gérer la réponse AJAX
	function responseHandler(source, data, file, token, path, lang, $this, loading, text) {
	    return function (response, statusText, jqXHR) {
	        if (response.action === 'success') {
	            if (response.callback === true) {
	                xhr_success(file, response, data, path, $this, lang);
	            } else {
	                if (response.msg != null) {
	                    toastr.success(response.msg);
	                }
	                if (response.url != null) {
	                    handleRedirect(response);
	                }
	            }
	        } else if (response.action === 'empty') {
	            if (response.msg != null) {
	                toastr.warning(response.msg);
	            }
	            if (response.fields) {
	                response.fields.forEach(field => {
	                    $(`#${field}`).addClass('is-invalid');
	                });
	            }
	        } else if (response.action === 'token') {
	            location.reload();
	        } else {
	            if (response.msg != null) {
	                toastr.error(response.msg);
	            }

	            if(response.session == 'expired') {
	            	setTimeout(function() {
					    location.reload();
					}, 3000);
	            }
	            logError(path, data, file, jqXHR.status, source, token, lang);
	        }

	        if (loading) {
	            setTimeout(() => {
	                $this.attr('data-kt-indicator', 'off');
	                $this.html(text.replace('Please wait...', ''));
	            }, 300);
	        }
	    };
	}

	// Fonction pour gérer la redirection
	function handleRedirect(response) {
	    const redirect = () => {
	        if (response.url === 'reload') {
	            location.reload();
	        } else {
	            location.href = response.url;
	        }
	    };
	    if (response.msg != null) {
	        setTimeout(redirect, 1500);
	    } else {
	        redirect();
	    }
	}

	// Fonction pour enregistrer les erreurs
	function logError(path, data, file, status, source, token, lang) {
	    $.post(
	        `${path}Connections/request/xhr/error-log.php`,
	        {
	            datas: data,
	            file: file,
	            status: status,
	            method: 'post',
	            source: source,
	            debug: true,
	            token: token,
	            lang: lang,
	        },
	        null,
	        'json'
	    );
	}

	function htmlspecialchars_decode(str) {
	    const textarea = document.createElement('textarea');
	    textarea.innerHTML = str;
	    const decoded = textarea.value; // Récupère la chaîne décodée
	    textarea.remove(); // Supprime l'élément
	    return decoded;
	}

	// bind un click sur les éléments portant le [data-xhr]
	// Pour les autres boutons, on laisse le binding générique
	$(document).on('click', '[data-xhr]', function(e) {
		var $this = $(this);

		if($this.data('trigger') === undefined) {
			if(!$this.is(':checkbox')) {
				e.preventDefault();
			}

			if($this.prop('tagName') == 'BUTTON') {
				var text = $this.text();

				$this.html('<span class="indicator-label">'+text+'</span><span class="indicator-progress">'+text+'... <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>');		
				$this.attr("data-kt-indicator", "on");
			}

			xhr_send(path, token, $this, null, lang);
		}
	});

	$(document).on('click', '[data-copy]', function(e) {
	    e.preventDefault();

	    var id = $(this).data('copy');
	    var $target = $('[data-copy-target=' + id + ']');
	    var plainText = '';
	    var htmlText = '';

	    // 1. Récupération du contenu selon le type d'élément
	    if ($target.prop('tagName') === 'INPUT' || $target.prop('tagName') === 'TEXTAREA') {
	        plainText = $target.val();
	        htmlText = plainText; // Pas de HTML possible dans un input/textarea
	    } else {
	        plainText = $target.text();
	        htmlText = $target.html(); // On récupère le formattage HTML
	    }

	    // 2. Vérification du protocole HTTPS (requis pour l'API Clipboard)
	    if (location.protocol === 'https:') {
	        
	        // Préparation des données pour le presse-papiers
	        const blobText = new Blob([plainText], { type: 'text/plain' });
	        const blobHtml = new Blob([htmlText], { type: 'text/html' });
	        
	        const data = [new ClipboardItem({
	            'text/plain': blobText,
	            'text/html': blobHtml
	        })];

	        navigator.clipboard.write(data).then(function() {
	            var copiedMsg;

	            // 3. Gestion de la langue
	            if (typeof lang !== 'undefined' && lang === 'fr') {
	                copiedMsg = 'Texte copié ! Saviez-vous que vous pouvez multi-diffuser cette offre gratuitement avec Genius People ?';
	            } else if (typeof lang !== 'undefined' && lang === 'nl') {
	                copiedMsg = 'gekopieerd';
	            } else {
	                copiedMsg = 'copied';
	            }

	            // 4. Affichage du feedback Toastr
	            if (plainText.length > 100) {
	                toastr.success(copiedMsg);
	            } else {
	                toastr.success(plainText + ' ' + copiedMsg + ' !');
	            }
	            
	        }).catch(function(err) {
	            toastr.error('Erreur lors de la copie : ' + err);
	        });

	    } else {
	        // Fallback ou message d'erreur pour le HTTP
	        toastr.error('La fonction de copie nécessite un protocole HTTPS sécurisé.');
	    }
	});

	$(document).on('click', '#btn-modal-questions', function() {
		var job = $('#job').val();
		console.log(job)

		$('#modal-questions .modal-body em').html(job);
	});

	// dropzone CV
	var myDropzone = null; // Déclaration globale
	// var myDropzone2 = null; // Déclaration globale
	var uploadedFileId = null;
	var uploadedCvId = null;

	// Fonction globale pour afficher une erreur
	// function showError(message) {
	//     $('#dropzone-error').html(`<p class="text-danger">${message}</p>`);
	// }

	// // Fonction globale pour effacer les erreurs
	// function clearError() {
	//     $('#dropzone-error').html('');
	// }

	
	function showError(message, errorContainerId) {
	    $(errorContainerId + '.dropzone-error').html(`<p class="text-danger">${message}</p>`);
	}

	function clearError(errorContainerId) {
	    $(errorContainerId + '.dropzone-error').html('');
	}


	/*function cv_dropzone(path) {
	    var dzContainer = document.getElementById("cv");
	    var dzMessage = dzContainer.querySelector(".dz-message");
	    var initialTemplate = dzMessage.innerHTML;
	    var job = $('[data-job]').data('job');

	    myDropzone = new Dropzone("#cv", { // Assigne à la variable globale
	        url: path + 'request/jobs/get-cv-info.php?lang=' + lang + '&job=' + job,
	        paramName: "cv",
	        maxFiles: 1,
	        maxFilesize: 5, // 5 Mo
	        acceptedFiles: ".pdf,.doc,.docx",
	        addRemoveLinks: true,
	        autoProcessQueue: true,
	        
	        init: function () {
	            this.on("success", function (file, response) {
	                try {
	                    var data = JSON.parse(response); // Convertir la chaîne JSON en objet
	                    
	                    if (data.is_cv !== "true" && data.is_cv !== true) {
	                        showError(translate.INVALID_CV_FILE);
	                        this.removeFile(file);
	                        return;
	                    }

                    	uploadedFileId = data.id;

	                    // Efface les erreurs si tout est bon
	                    clearError();

	                    // Mise à jour des champs du formulaire UNIQUEMENT s'ils sont vides
	                    if ($('#firstname').val().trim() === "") {
	                        $('#firstname').val(data.firstname || '');
	                    }
	                    if ($('#lastname').val().trim() === "") {
	                        $('#lastname').val(data.lastname || '');
	                    }
	                    if ($('#email').val().trim() === "") {
	                        $('#email').val(data.email || '');
	                    }
	                    if ($('#phone').val().trim() === "") {
	                        $('#phone').val(data.phone || '');
	                    }
	                } catch (e) {
	                    showError(translate.FILE_PROCESSING_ERROR);
	                    this.removeFile(file);
	                }
	            });

	            this.on("error", function (file, errorMessage) {
	                if (file.size > this.options.maxFilesize * 1024 * 1024) { 
	                    showError(translate.FILE_TOO_LARGE);
	                } else if (file.accepted === false) {
	                    showError(translate.INVALID_FILE_FORMAT);
	                } else if (errorMessage.includes("too many files")) {
	                    showError(translate.SINGLE_FILE_ONLY);
	                } else {
	                    showError(translate.FILE_UPLOAD_ERROR);
	                }
	                
	                this.removeFile(file);
	            });

	            this.on("maxfilesexceeded", function (file) {
	                showError(translate.SINGLE_FILE_ONLY);
	                this.removeFile(file);
	            });

	            this.on("addedfile", function () {
	                clearError();
	            });
	        }
	    });
	}

	// Initialisation de Dropzone si l'élément existe
	if ($('#cv').length > 0) {
	    cv_dropzone(path);
	}*/

	function cv_dropzone(path) {
	    var dzContainer = document.getElementById("cv");
	    var dzMessage = dzContainer.querySelector("#cv .dz-message");
	    var initialTemplate = dzMessage.innerHTML;
	    var job = $('[data-job]').data('job');
	    var form = $('[data-form]').data('form');
	    var docDropzoneInitialized = false;

	    myDropzone = new Dropzone("#cv", { // Assigne à la variable globale
	        url: path + 'request/jobs/get-cv-info.php?lang=' + lang + '&job=' + job+ '&form=' + form+ '&folder=cv',
	        paramName: "cv",
	        maxFiles: 1,
	        maxFilesize: 5, // 5 Mo
	        acceptedFiles: ".pdf,.doc,.docx,.odt,.jpg,.jpeg,.png",
	        addRemoveLinks: true,
	        autoProcessQueue: true,
	        
	        init: function () {
	            this.on("success", function (file, response) {
	            	file.uploadedId = null;
	                try {
	                    var data = JSON.parse(response); // Convertir la chaîne JSON en objet
	                    
	                    if (data.is_cv !== "true" && data.is_cv !== true) {
	                        showError(translate.INVALID_CV_FILE, '#cv-error');
	                        this.removeFile(file);
	                        return;
	                    }

                    	file.uploadedId = data.id;
                    	uploadedCvId = data.id

	                    // Efface les erreurs si tout est bon
	                    clearError('#cv-error');

	                    // Mise à jour des champs du formulaire UNIQUEMENT s'ils sont vides
	                    if ($('#firstname').val().trim() === "") {
	                        $('#firstname').val(data.firstname || '');
	                    }
	                    if ($('#lastname').val().trim() === "") {
	                        $('#lastname').val(data.lastname || '');
	                    }
	                    if ($('#email').val().trim() === "") {
	                        $('#email').val(data.email || '');
	                    }
	                    if ($('#phone').val().trim() === "") {
	                        $('#phone').val(data.phone || '');
	                    }

	                    $('#docs-box').removeClass('d-none');
	                    $('#motiv-box').removeClass('d-none');
	                    if (!docDropzoneInitialized) {
					        doc_dropzone(path);
					        docDropzoneInitialized = true;
					    }
	                } catch (e) {
	                    showError(translate.FILE_PROCESSING_ERROR, '#cv-error');
	                    this.removeFile(file);
	                }
	            });

	            this.on("error", function (file, errorMessage) {
	                if (file.size > this.options.maxFilesize * 1024 * 1024) { 
	                    showError(translate.FILE_TOO_LARGE, '#cv-error');
	                } else if (file.accepted === false) {
	                    showError(translate.INVALID_FILE_FORMAT, '#cv-error');
	                } else if (errorMessage.includes("too many files")) {
	                    showError(translate.SINGLE_FILE_ONLY, '#cv-error');
	                } else {
	                    showError(translate.FILE_UPLOAD_ERROR, '#cv-error');
	                }
	                
	                this.removeFile(file);
	            });

	            this.on("removedfile", function(file) {
			        // On vérifie qu'on a un ID de fichier côté serveur
			        if (file.uploadedId) {
			        	var $this = $('#cv');
        				$this.attr('data-id', file.uploadedId);
        				$this.data('id', file.uploadedId);
        				$this.attr('data-type', 'cv');
        				$this.data('type', 'cv');

			            xhr_send(path, token, $this, 'jobs/remove-cv', lang);
			        }
			    });

	            this.on("maxfilesexceeded", function (file) {
	                showError(translate.SINGLE_FILE_ONLY, '#cv-error');
	                this.removeFile(file);
	            });

	            this.on("addedfile", function () {
	                clearError('#cv-error');
	            });
	        }
	    });
	}

	function doc_dropzone(path) {
	    var dzContainer = document.getElementById("docs");
	    var dzMessage = dzContainer.querySelector("#docs-box .dz-message");
	    var initialTemplate = dzMessage.innerHTML;
	    var job = $('[data-job]').data('job');
	    var form = $('[data-form]').data('form');

	    myDropzone_doc = new Dropzone("#docs", { // Assigne à la variable globale
	        url: path + 'request/jobs/docs.php?lang=' + lang + '&job=' + job+ '&form=' + form+ '&folder=doc',
	        paramName: "doc",
	        maxFiles: 3,
	        maxFilesize: 5, // 5 Mo
	        acceptedFiles: ".pdf,.doc,.docx,.odt,.jpg,.jpeg,.png",
	        addRemoveLinks: true,
	        autoProcessQueue: true,
	        
	        init: function () {
	            this.on("success", function (file, response) {
	            	file.uploadedId = null;
	                try {
	                   var data = JSON.parse(response); // Convertir la chaîne JSON en objet
	                    file.uploadedId = data.id;
	                } catch (e) {
	                    showError(translate.FILE_PROCESSING_ERROR, '#docs-error');
	                    this.removeFile(file);
	                }
	            });

	            this.on("error", function (file, errorMessage) {
	                if (file.size > this.options.maxFilesize * 1024 * 1024) { 
	                    showError(translate.FILE_TOO_LARGE, '#docs-error');
	                } else if (file.accepted === false) {
	                    showError(translate.INVALID_FILE_FORMAT, '#docs-error');
	                } else if (errorMessage.includes("too many files")) {
	                    showError(translate.SINGLE_FILE_ONLY, '#docs-error');
	                } else {
	                    showError(translate.FILE_UPLOAD_ERROR, '#docs-error');
	                }
	                
	                this.removeFile(file);
	            });

	            this.on("removedfile", function(file) {
			        // On vérifie qu'on a un ID de fichier côté serveur
			        if (file.uploadedId) {	            

			        	var $this = $('#docs-box');
        				$this.attr('data-id', file.uploadedId);
        				$this.data('id', file.uploadedId);
        				$this.attr('data-type', 'doc');
        				$this.data('type', 'doc');

			            xhr_send(path, token, $this, 'jobs/remove-cv', lang);
			        }
			    });

	            this.on("maxfilesexceeded", function (file) {
	                showError(translate.SINGLE_FILE_ONLY, '#docs-error');
	                this.removeFile(file);
	            });

	            this.on("addedfile", function () {
	                clearError('#docs-error');
	            });
	        }
	    });
	}

	// Initialisation de Dropzone si l'élément existe
	if ($('#cv').length > 0) {
	    cv_dropzone(path);
	}

	// init tooltip
	$('[data-bs-toggle="tooltip"]').tooltip();

});

function check_pw(password) {
	var $this = $(password);
	var pw = $this.val();
	var test = true;
	// At least one LOWERCASE character:
	var lowerCasePattern = /^(?=.*[a-z]).+$/;

	if(lowerCasePattern.test(pw)) {		    
		$('.lowercase').addClass('valid-regex');
	}
	else {
		$('.lowercase').removeClass('valid-regex');
		test = false;
	}

    // At least one UPPERCASE character:
    var upperCasePattern = /^(?=.*[A-Z]).+$/;
    
    if(upperCasePattern.test(pw)) {		    
    	$('.uppercase').addClass('valid-regex');
    }
    else {
    	$('.uppercase').removeClass('valid-regex');
    	test = false;
    }

    // At least one NUMBER:
    var numberPattern = /^(?=.*[\d]).+$/;
    
    if(numberPattern.test(pw)) {		    
    	$('.number').addClass('valid-regex');
    }
    else {
    	$('.number').removeClass('valid-regex');
    	test = false;
    }

    // At least one SPECIAL character:
    var specialCharacterPattern = /([-+=_!@#$%^&*.,;:'\"<>/?`~\[\]\(\)\{\}\\\|\s])/;

    if(specialCharacterPattern.test(pw)) {		    
    	$('.specialcase').addClass('valid-regex');
    }
    else {
    	$('.specialcase').removeClass('valid-regex');
    	test = false;
    }

    // At least 8 characters in the screen:
    var characterCountPattern = /^.{8,}/;

    if(characterCountPattern.test(pw)) {		    
    	$('.minimumcase').addClass('valid-regex');
    }
    else {
    	$('.minimumcase').removeClass('valid-regex');
    	test = false;
    }

    if($('.not-secure li').length == $('.valid-regex').length) {
    	$this.closest('form').addClass('valid');
    }
    else {
    	$this.closest('form').removeClass('valid');
    }
}